import { QuestionsStep } from '../types';

export const QUESTIONS_STEPS = 10;

export const nextStep = (step: QuestionsStep): QuestionsStep => {
  return (step === QUESTIONS_STEPS ? 1 : step + 1) as QuestionsStep;
};

export const prevStep = (step: QuestionsStep): QuestionsStep => {
  return (step - 1) as QuestionsStep;
};
